import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import LoadingPage from '../components/LoadingPage';
import MoreSvg from '../../svg/admin/More';
import BinSvg from '../../svg/admin/Bin';
import RemoveSvg from '../../svg/admin/Remove';
import _ from 'lodash';
import { teacherFetchSchoolInfo, teacherUpdateSchoolById } from '../../services2/schools.service';
import { teacherDeleteUser, teacherFetchUserList, teacherInsertNewStudent, teacherInsertNewTeacher, teacherUpdateUser } from '../../services2/users.service';
import { isValidEmail } from '../../util/utils';
import { teacherChangePassword } from '../../services2/request.service';
import * as XLSX from 'xlsx';

function Component(props) {
  const { id } = useParams();
  const navigate = useNavigate();
  const [data, setdata] = useState(null)
  const [isLoading, setisLoading] = useState(false)

  const [isAddingTeacher, setisAddingTeacher] = useState(null)
  const [isDeletingUser, setisDeletingUser] = useState(null)

  const handleDeleteUser = async () => {
    setisLoading(true)
    let result = await teacherDeleteUser(props.token.token, isDeletingUser._id);
    if (result.errno) {
      alert(result.message)
    } else {
      alert('刪除成功')
      setisDeletingUser(null)
      await fetchTeahcers()
    }
    setisLoading(false)
  }

  const handleAddTeacher = async () => {
      if ((!isAddingTeacher.name) || isAddingTeacher.name.length < 2) {
        alert('請輸入有效的名字')
        return
      }
      if ((!isAddingTeacher.username) || (!isValidEmail(isAddingTeacher.username)) || isAddingTeacher.username.length < 5) {
        alert('請輸入有效的電子郵件')
        return
      }
      if ((!isAddingTeacher._id) && ((!isAddingTeacher.password) || isAddingTeacher.password.length < 5)) {
        alert('請輸入有效的密碼')
        return
      }
      setisLoading(true)
      let result =
        isAddingTeacher?._id ?
          await teacherUpdateUser(props.token.token, isAddingTeacher._id, { name: isAddingTeacher.name, mobile: isAddingTeacher.mobile })
          : await teacherInsertNewTeacher(props.token.token, isAddingTeacher?.username, isAddingTeacher?.password, isAddingTeacher?.name, isAddingTeacher.mobile);
      if (result.errno) {
        alert(result.message)
      } else {
        alert(isAddingTeacher._id ? '更新成功' : '添加成功')
        setisAddingTeacher(null)
        await fetchTeahcers()
      }
      setisLoading(false)
    }

  const fetchData = async () => {
    let result = await teacherFetchSchoolInfo(props.token.token, id);
    if (result.result) {
      setdata(result.result)
    } else {
      console.log('Fetch data error')
    }
  }
  const [teachers, setTeachers] = useState([])
  const fetchTeahcers = async () => {
    let result = await teacherFetchUserList(props.token.token, { type: 'teacher' }, { limit: 9999 });
    if (result.result) {
      setTeachers(result.result || [])
    } else {
      console.log('Fetch data error')
    }
  }



  const handleSave = async () => {
    if (isLoading) return
    setisLoading(true)
    let result = await teacherUpdateSchoolById(props.token.token, {
      name: data.name || '',
      data: data.data || {},
    });
    if (result.errno) {
      alert(result.message)
    } else {
      alert('儲存成功')
    }
    setisLoading(false)
  }

  const handleUpdateField = (field) => (e) => {
    setdata({ ...data, [field]: e.target.value })
  }

  const refresh = async () => {
    if (isLoading) return
    setisLoading(true)
    await fetchData()
    await fetchTeahcers()
    setisLoading(false)
  }

  useEffect(() => {
    refresh()
  }, [id])


  const openNewTab = (url) => () => {
    window.open(url, '_blank').focus();
  }


  return (
    <div className='relative h-full flex-1 bg-[#F2F2F2] flex-col flex p-[16px] gap-[16px] text-[16px] text-[black]'>
      {/*buttons*/}
      <div className='flex flex-row items-center justify-between items-center gap-[8px] flex-wrap'>
        <div></div>
        <div className='flex flex-row gap-[8px] flex-wrap '>
          {/* <div className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>刪除</div> */}
          <div onClick={handleSave} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>儲存</div>
        </div>
      </div>
      {/*end of buttons*/}

      <div className='w-full flex flex-row gap-[16px] mt-[16px] flex-wrap'>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>學校名稱</div>
          <input value={data?.name || ''} onChange={handleUpdateField('name')} placeholder='學校名稱' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>學校電話</div>
          <input value={data?.data?.telephone || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), telephone: e.target.value } }) }} placeholder='電話' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>學校傳真</div>
          <input value={data?.data?.fax || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), fax: e.target.value } }) }} placeholder='傳真' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>學校校長</div>
          <input value={data?.data?.principalName || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), principalName: e.target.value } }) }} placeholder='學校校長' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>負責老師</div>
          <input value={data?.data?.teacherName || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), teacherName: e.target.value } }) }} placeholder='負責老師' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>老師電話</div>
          <input value={data?.data?.teacherTel || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), teacherTel: e.target.value } }) }} placeholder='老師電話' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>老師電郵</div>
          <input value={data?.data?.teacherEmail || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), teacherEmail: e.target.value } }) }} placeholder='老師電郵' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
        <div className='flex-[3] flex flex-col gap-[8px] min-w-[300px]'>
          <div className='font-[700]'>備注</div>
          <input value={data?.data?.remarks || ''} onChange={(e) => { setdata({ ...data, data: { ...(data?.data || {}), remarks: e.target.value } }) }} placeholder='備注' className='rounded-[7px] px-[8px] py-[4px] font-[400]' />
        </div>
      </div>
      <div className='w-full flex flex-row gap-[16px] mt-[16px] flex-wrap'>
        <div className='font-[700]'>附件:</div>
        {data?.data?.attachments?.map((item, index) =>
          <div key={item || index} className='items-center cursor-pointer hover:opacity-[.5]' onClick={openNewTab(item)}>
            <img className='w-[24px] h-[24px]' src='/images/file_icon.png' />
          </div>
        )}
      </div>


      {/*teacher*/}
      <div className='w-full flex flex-row gap-[48px] mt-[16px] flex-wrap justify-between items-center'>
        <div className='font-[700]'>老師資料</div>
        <div onClick={() => { setisAddingTeacher({}) }} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
          添加
        </div>
      </div>


      {/*list of teachers*/}
      <div className='flex flex-col flex-1 w-full bg-[white] rounded-[10px] p-[16px] text-[14px]' style={{ overflowY: 'auto' }}>
        <div className='w-full flex flex-row justify-between font-bold py-[16px]' style={{ borderBottom: '1px solid #D1D1D1' }}>
          <div className='flex-1'>老師姓名</div>
          <div className='flex-1'>聯絡電話</div>
          <div className='flex-1'>電郵</div>
          <div className='flex-1'>狀態</div>
          {/* <div className='w-[32px] mr-[8px]'></div>
          <div className='w-[32px]'></div> */}
        </div>
        {teachers?.map((item, index) =>
          <div key={item?._id || index} className='w-full flex flex-row justify-between font-[400] py-[16px] items-center' style={{ borderBottom: '1px solid #D1D1D1' }}>
            <div className='flex-1'>{item?.name}</div>
            <div className='flex-1'>{item?.mobile || ''}</div>
            <div className='flex-1'>{item?.username || ''}</div>
            <div className='flex-1 flex flex-row'>
              {item.status === 'active' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#DBFFF0] text-[#4DE0A4]'>Active</div>
                : item.status === 'inactive' ? <div className='text-[12px] rounded-[99px] px-[24px] py-[6px] bg-[#FFC8C899] text-[#F06969]'>Inactive</div>
                  : <div>{item.status}</div>
              }
            </div>
            <div onClick={() => { setisAddingTeacher(item) }} className='w-[32px] bg-[#FFD8D0] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5] mr-[8px]'>
              <MoreSvg />
            </div>
            <div onClick={() => { setisDeletingUser(item) }} className='w-[32px] bg-[#E2E2E2] h-[32px] rounded-[5px] flex justify-center items-center cursor-pointer hover:opacity-[.5]'>
              <BinSvg />
            </div>
          </div>
        )}
      </div>
      {/*end of list of teachers*/}

      {isAddingTeacher &&
        <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
          <div className='flex flex-col gap-[8px] bg-[white] p-[16px] rounded-[7px] max-w-[400px] w-full'>
            <div className='font-[700]'>老師姓名</div>
            <input value={isAddingTeacher?.name} onChange={e => { setisAddingTeacher({ ...isAddingTeacher, name: e.target.value }) }} placeholder='姓名' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            <div className='font-[700]'>電郵</div>
            <input disabled={isAddingTeacher?._id} value={isAddingTeacher?.username} onChange={e => { setisAddingTeacher({ ...isAddingTeacher, username: e.target.value }) }} placeholder='電郵' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            <div className='font-[700]'>聯絡電話</div>
            <input value={isAddingTeacher?.mobile} onChange={e => { setisAddingTeacher({ ...isAddingTeacher, mobile: e.target.value }) }} placeholder='聯絡電話' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            {isAddingTeacher?._id ?
              <div />
              : <div className='font-[700]'>密碼</div>
            }
            {isAddingTeacher?._id ?
              <div />
              : <input value={isAddingTeacher?.password} onChange={e => { setisAddingTeacher({ ...isAddingTeacher, password: e.target.value }) }} placeholder='密碼' className='rounded-[7px] px-[8px] py-[4px] font-[400]' style={{ border: '1px solid black' }} />
            }

            <div className='w-full flex flex-row gap-[16px] mt-[16px] flex-wrap justify-center items-center'>
              <div onClick={handleAddTeacher} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
                {isAddingTeacher?._id ? '更新' : '添加'}
              </div>
              <div onClick={() => { setisAddingTeacher(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>
                取消
              </div>
            </div>
          </div>
        </div>}
      {/*end of add/edit teacher popup*/}


      {/*delete user popup*/}
      {isDeletingUser &&
        <div className='fixed top-0 left-0 w-full h-full bg-[#00000090] flex flex-col justify-center items-center'>
          <div className='flex flex-col gap-[8px] bg-[white] p-[16px] rounded-[7px] max-w-[400px] w-full'>
            <div className='font-[700]'>姓名:</div>
            <div> {isDeletingUser?.name} </div>
            <div className='font-[700]'>電郵:</div>
            <div> {isDeletingUser?.username} </div>
            <div className='w-full flex flex-row gap-[16px] mt-[24px] flex-wrap justify-center items-center'>
              <div onClick={handleDeleteUser} className='text-[white] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5] bg-[#1F4CC8]' style={{ border: '1px solid #1F4CC8' }}>
                刪除
              </div>
              <div onClick={() => { setisDeletingUser(null) }} className='text-[#1F4CC8] text-[16px] font-[700] px-[16px] py-[4px] rounded-[7px] cursor-pointer hover:opacity-[.5]' style={{ border: '1px solid #1F4CC8' }}>
                取消
              </div>
            </div>
          </div>
        </div>
      }
      {/*end of delete user popup*/}



      {isLoading && <LoadingPage />}
    </div>
  );
}

export default connect((store) => {
  return {
    token: store.tokenReducer,
  }
})(Component)
